var _circle, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoEmployment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    width: "150px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 60,
    fill: "#ddd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.26,108.08c0-3.81-4.08-6.89-24-6.89s-24,3.09-24,6.89S7.42,115,27.3,115,51.26,111.88,51.26,108.08Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100,43.17V50.7A56.37,56.37,0,0,0,71,64.85a58,58,0,0,0-29-14.15V43.17",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.03 24.21 27.99 38.55 71.03 52.9 114.07 38.55 71.03 24.21",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.51,
    y1: 55.75,
    x2: 49.51,
    y2: 67.65,
    fill: "none",
    stroke: "#0af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "71.03 38.55 49.51 45.73 49.51 58.25",
    fill: "none",
    stroke: "#0af",
    strokeLinejoin: "round",
    strokeDasharray: "4 1.5 2 1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.03,
    cy: 38.55,
    r: 0.75,
    transform: "translate(-8.55 24.44) rotate(-18.44)",
    fill: "#0af"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "127.83 83.44 127.83 119.8 70.18 120.31 70.18 83.61 99 63.32 127.83 83.44",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.83 83.44 127.83 87.56 96.51 65.07 99 63.32 127.83 83.44",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.75,
    y: 73.56,
    width: 8.5,
    height: 12.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.63,
    y: 98.83,
    width: 8.5,
    height: 11.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.81,
    y: 98.83,
    width: 8.5,
    height: 11.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "65.5 86.67 99 63.28 132.51 86.67",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "107.23 120.15 107.23 98.48 117.63 98.48 117.63 120.15",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.23,
    y1: 98.48,
    x2: 117.63,
    y2: 98.48,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "75.89 97.71 80.98 93.88 92.95 93.88 98.04 97.71",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.85,125c-4,0-12.52.33-12.75-.47-4.2-.05-5.19-3.13-5.19-4.06s-.25-3.88,5.29-5.05c.28-2.48,1.77-4.52,4.77-4.52,4-.59,6.24.53,7.22,2.29",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.16,113.86c.06-3.64,4.23-4.5,5.33-4.5a6.23,6.23,0,0,1,6.47,4.8c2.89.25,5.37,3.87,5.86,4.56,1.8,9-14.43,5.78-16.26,5.78",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.63,100.51c.57,3.61-5.37,9.31-13.62,9.38C16,110,8.3,111.62,8.3,106.2c0-3.66,5.94-10.94,14-12.51S37.06,96.9,37.63,100.51Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.79,100.51c-.57,3.61,5.37,9.31,13.62,9.38,8.06.07,15.71,1.73,15.71-3.7,0-3.66-5.94-10.94-14-12.51S19.37,96.9,18.79,100.51Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,79.85c0-2.57-5.75-4.65-12.83-4.65s-12.83,2.08-12.83,4.65c0,1.47,1.87,2.77,4.79,3.62a19.74,19.74,0,0,0-3.08,10.92c0,8.74,5,15.82,11.12,15.82s11.12-7.08,11.12-15.82a19.74,19.74,0,0,0-3.08-10.92C39.17,82.62,41,81.31,41,79.85Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.47,78c-1.9-1.26-5.47.78-8,4.55A16.09,16.09,0,0,0,10.65,84c-1.17,1.12-2.09,3.32-3,5.76a7.15,7.15,0,0,0-.48,2.08h0a1.15,1.15,0,0,0,0,1.53A1.21,1.21,0,0,0,7.13,95a1.48,1.48,0,0,0,.92.57,1.42,1.42,0,0,0,.3,1.15,1.21,1.21,0,0,0,1.56.45l.26.1a1.77,1.77,0,0,0,.12.22,1.42,1.42,0,0,0,1.93.46,1.15,1.15,0,0,0,.4-1c1.53-1,2.81-3.25,3.19-6.06,0-.28.06-.55.08-.82a15,15,0,0,0,2.5-2.92C20.89,83.33,21.37,79.25,19.47,78Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.71,84.47c-.82,1.22-.5,1.11-1,2.65",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,78c1.9-1.26,5.47.78,8,4.55A16.09,16.09,0,0,1,45.77,84c1.17,1.12,2.09,3.32,3,5.76a7.15,7.15,0,0,1,.48,2.08h0a1.15,1.15,0,0,1,0,1.53A1.21,1.21,0,0,1,49.29,95a1.48,1.48,0,0,1-.92.57,1.42,1.42,0,0,1-.3,1.15,1.21,1.21,0,0,1-1.56.45l-.26.1a1.77,1.77,0,0,1-.12.22,1.42,1.42,0,0,1-1.93.46,1.15,1.15,0,0,1-.4-1c-1.53-1-2.81-3.25-3.19-6.06,0-.28-.06-.55-.08-.82A15,15,0,0,1,38,87.1C35.54,83.33,35.05,79.25,37,78Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.72,84.47c.82,1.22.5,1.11,1,2.65",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.25,67.75c0-1.23-.72-2.23-1.61-2.23h0A7.09,7.09,0,0,0,40,63.24c0-4.41-4.1-8.06-9.48-8.76-.61-1-1.19-2.42,1.36-4.75-2.87,0-6.74,2-5.87,4.87-5,.93-8.71,4.44-8.71,8.64a7.09,7.09,0,0,0,.39,2.28h0c-.88,0-1.6,1-1.6,2.23a2.25,2.25,0,0,0,1.15,2.13,5.21,5.21,0,0,0-.12,1.06c0,2.8,2.26,5.25,5.62,6.59.81,1.18,3.14,2,5.92,2s5.11-.86,5.92-2c3.36-1.34,5.62-3.79,5.62-6.59a5.21,5.21,0,0,0-.12-1.06A2.25,2.25,0,0,0,41.25,67.75Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.27,76.45a12,12,0,0,0,2.49,1.34c.81,1.18,3.14,2,5.92,2s5.11-.86,5.92-2a12.26,12.26,0,0,0,2.21-1.14",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.21,111.82c-8-.38-9-10.23-11.7-14.44-2.89-4.48,5.24-.56,11.7-.56s14.59-3.92,11.7.56C37.19,101.59,36.25,111.45,28.21,111.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.63,
    y1: 91.91,
    x2: 28.38,
    y2: 91.91,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.01,
    y1: 55.78,
    x2: 25.76,
    y2: 55.03,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 31.98,
    y1: 71.91,
    x2: 33.02,
    y2: 71.4,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.39,
    y1: 71.87,
    x2: 24.34,
    y2: 71.36,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 28.68,
    cy: 71.91,
    r: 2.89,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.57,
    y1: 71.91,
    x2: 27.57,
    y2: 71.91,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.28,
    cy: 64.9,
    rx: 1.02,
    ry: 2.07,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.09,
    cy: 64.9,
    rx: 1.02,
    ry: 2.07,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.55,104.11c-.61-2.47-5.11-3.49-10.06-2.28a16.93,16.93,0,0,0-4.14,1.59,2.66,2.66,0,0,0-1.94-.27c-2,.27-3.33,2.73-2.92,5.79a7.84,7.84,0,0,0,.81,2.56,1.14,1.14,0,0,0-.36,1,1.36,1.36,0,0,0,1.5,1,.77.77,0,0,0,0,.26,1.2,1.2,0,0,0,1.44.82,1.45,1.45,0,0,0,1-.56h.08a3.54,3.54,0,0,0,2.64-2.68,17,17,0,0,0,4.14-.51C44.64,109.57,48.16,106.58,47.55,104.11Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.87,101.32a16.77,16.77,0,0,0-4,.43",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.87,108.8a3.22,3.22,0,0,1,0,2",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.95,111.17c.14-.72,1.19-1.6,1-1.53",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.87,104.11c.61-2.47,5.11-3.49,10.06-2.28a16.93,16.93,0,0,1,4.14,1.59,2.66,2.66,0,0,1,1.94-.27c2,.27,3.33,2.73,2.92,5.79a7.84,7.84,0,0,1-.81,2.56,1.14,1.14,0,0,1,.36,1,1.36,1.36,0,0,1-1.5,1,.77.77,0,0,1,0,.26,1.2,1.2,0,0,1-1.44.82,1.45,1.45,0,0,1-1-.56h-.08a3.54,3.54,0,0,1-2.64-2.68,17,17,0,0,1-4.14-.51C11.79,109.57,8.27,106.58,8.87,104.11Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.55,101.32a16.77,16.77,0,0,1,4,.43",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.55,108.8a3.22,3.22,0,0,0,0,2",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.47,111.17c-.14-.72-1.19-1.6-1-1.53",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEmployment);
export default __webpack_public_path__ + "static/media/no-employment.ab32a2f7.svg";
export { ForwardRef as ReactComponent };